import React from 'react';

import useAppContext from '../../../../context/useAppContext';

import WidgetEvent from '../../../../models/widgetEvent';
import { useParams } from 'react-router-dom';
import Loading from '../../../../components/loading';
import NewFilteredWidget from './filtered-widget';
import Widget from '../../../../models/widget';

export default function EditFilteredWidget() {
    const [{ organization }] = useAppContext();
    const { widget_id } = useParams();
    const [matchingWidget, onMatchingWidget] = React.useState(null);

    const [widget, loadingWidget, sync] = WidgetEvent.useApiModel(
        {
            organizationId: organization.pk,
            id: widget_id,
            launch: Boolean(widget_id),
            query: {
                sync: false,
                expand: 'event,contingents,inventories'
            },
            onSuccess: widgetEvent => {
                Widget.findOne(
                    {
                        organizationId: organization.pk
                    },
                    {
                        widget_key: widgetEvent.widget_event_key
                    }
                )
                    .then(widget => {
                        if (!widget) {
                            return onMatchingWidget(null);
                        }

                        onMatchingWidget(widget);
                    })
                    .catch(e => {
                        // Pass
                    });
            }
        },
        [widget_id, onMatchingWidget]
    );

    if (loadingWidget) {
        return <Loading />;
    }

    return <NewFilteredWidget widget={widget} matchingWidget={matchingWidget} sync={sync} />;
}
